import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { FaFire, FaTag } from "react-icons/fa";
import { FiClock } from "react-icons/fi";
import { Helmet } from "react-helmet-async";


export default function RoomDetail() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [room, setRoom] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [activeImage, setActiveImage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalIndex, setModalIndex] = useState(0);
    const [showBookingModal, setShowBookingModal] = useState(false);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [checkIn, setCheckIn] = useState("");
    const [checkOut, setCheckOut] = useState("");
    const [guests, setGuests] = useState(1);
    const [bookingLoading, setBookingLoading] = useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha();
    const today = new Date().toISOString().split("T")[0];
    const selectedDate = checkIn || today;
    const { hotelSlug, roomId } = useParams();



    useEffect(() => {
        document.body.style.overflow = showBookingModal ? "hidden" : "auto";
    }, [showBookingModal]);



    // useEffect(() => {
    //     console.log("ROOM DATA 👉", room);
    // }, [room]);

    useEffect(() => {
        const fetchRoom = async () => {
            try {
                const res = await axios.get(
                    `https://hotel.southtravels.com/api/rooms/${roomId}`
                );

                setRoom(res.data);



                setActiveImage(res.data.image);
            } catch (err) {
                console.error(err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchRoom();
    }, [roomId]);



    if (loading) {
        return (
            <div className="flex flex-col justify-center items-center h-screen">
                <div className="animate-spin h-10 w-10 border-4 border-teal-500 border-t-transparent rounded-full"></div>
                <p className="mt-3 text-gray-500">Loading room...</p>
            </div>
        );
    }


    if (error || !room) {
        return (
            <div className="h-screen flex flex-col justify-center items-center">
                <p className="text-red-500 text-lg">Room not found</p>
                <button onClick={() => navigate(-1)} className="mt-3 text-teal-600">
                    Go Back
                </button>
            </div>
        );
    }

    let images = [];
    try {
        images = room.images ? JSON.parse(room.images) : [];
    } catch {
        images = [];
    }

    const amenities = room.amenities ? JSON.parse(room.amenities) : [];

    const allImages = [room.image, ...images];

    const user = JSON.parse(localStorage.getItem("user"));



    const getOriginalPrice = () => {
        return Number(room?.price || 0);
    };

    const getNights = () => {
        if (!checkIn || !checkOut) return 1;

        const start = new Date(checkIn);
        const end = new Date(checkOut);

        const diffTime = end - start;

        const nights = Math.ceil(
            diffTime / (1000 * 60 * 60 * 24)
        );

        return nights > 0 ? nights : 1;
    };

    const getBookingTotal = () => {
        return nightlyRate * getNights();
    };

    const getTourismFee = () => {
        return Number(room?.hotel?.rating) === 5 ? 20 : 10;
    };

    // const getFinalPriceBreakdown = () => {
    //     const base = nightlyRate;
    //     const nights = getNights();

    //     const serviceCharge = 0.10;
    //     const vat = 0.05;
    //     const tourismFee = 10;

    //     const taxRate = serviceCharge + vat;

    //     const nightlyWithTax = base + (base * taxRate) + tourismFee;

    //     const total = Math.round(nightlyWithTax * nights);

    //     return {
    //         base,
    //         nights,
    //         serviceCharge,
    //         vat,
    //         tourismFee,
    //         nightlyWithTax,
    //         total
    //     };
    // };


    const getFinalPriceBreakdown = () => {
        const base = nightlyRate;
        const nights = getNights();

        const serviceCharge = 0.10;
        const vat = 0.05;

        const tourismFee = getTourismFee();

        const taxRate = serviceCharge + vat;

        const nightlyWithTax = base + (base * taxRate) + tourismFee;

        const total = Math.round(nightlyWithTax * nights);

        return {
            base,
            nights,
            serviceCharge,
            vat,
            tourismFee,
            nightlyWithTax,
            total
        };
    };


    const handleBooking = async () => {

        if (!name || !email || !phone || !checkIn || !checkOut) {
            alert("Please fill all fields");
            return;
        }

        if (new Date(checkOut) <= new Date(checkIn)) {
            alert("Check-out must be after Check-in");
            return;
        }

        if (!executeRecaptcha) {
            alert("Captcha not ready. Refresh page.");
            return;
        }

        try {
            setBookingLoading(true);

            const token = await executeRecaptcha("room_booking");

            // BUILD DATA OBJECT
            const bookingData = {
                user_id: user?.id,
                hotel_id: room?.hotel?.id ?? room?.hotel_id,
                room_id: room.id,
                room_name: room.name || `Room ${room.room_number}`,

                room_price: room.price,
                discount_price: room.discount_price || null,

                name,
                email,
                phone,

                check_in: checkIn,
                check_out: checkOut,
                guests,
                season_name: activeSeason?.season_name || null,
                season_start: activeSeason?.start_date || null,
                season_end: activeSeason?.end_date || null,

                total_amount: getFinalPriceBreakdown().total,
                nights: getNights(),

                captcha: token
            };

            const res = await axios.post(
                "https://hotel.southtravels.com/api/hotel-payment",
                bookingData
            );

            if (res.data.payment_url) {
                window.location.href = res.data.payment_url;
            } else {
                alert("❌ Payment URL not received");
            }

        } catch (err) {
            if (err.response) {
                alert(`❌ ${err.response.data.error || err.response.data.message}`);
            } else {
                alert("❌ Server error");
            }

        } finally {
            setBookingLoading(false);
        }
    };



    const getRoomPrice = (room) => {
        return room?.discount_price
            ? Number(room.discount_price)
            : Number(room.price);
    };

    const getFinalRoomPrice = (room) => {
        const breakdown = getFinalPriceBreakdown();
        return Math.round(breakdown.nightlyWithTax);
    };

    const roundPrice = (value) => {
        return Math.round(Number(value));
    };

    const todayDate = new Date();

    const isDiscounted =
        room?.discount_price &&
        Number(room.discount_price) < Number(room.price);

    // const activeSeason = room?.seasonal_prices?.find(season => {
    //     if (!checkIn) return false;

    //     const date = new Date(checkIn);
    //     return date >= new Date(season.start_date) &&
    //         date <= new Date(season.end_date);
    // });

    const activeSeason = room?.seasonal_prices?.find(season => {

        // use check-in date if selected
        // otherwise use today's date
        const date = checkIn
            ? new Date(checkIn)
            : new Date();

        return date >= new Date(season.start_date) &&
            date <= new Date(season.end_date);
    });

    // const nightlyRate = (() => {
    //     if (!room) return 0;

    //     const original = Number(room.price);

    //     const discounted = room.discount_price
    //         ? Number(room.discount_price)
    //         : original;

    //     if (room.seasonal_prices?.length > 0) {
    //         const date = new Date(selectedDate);

    //         const match = room.seasonal_prices.find(season => {
    //             const start = new Date(season.start_date);
    //             const end = new Date(season.end_date);
    //             return date >= start && date <= end;
    //         });

    //         if (match) {
    //             return Number(match.price);
    //         }
    //     }

    //     return discounted;
    // })();

    const nightlyRate = (() => {
        if (!room) return 0;

        // Start with original price
        let finalPrice = Number(room.price);

        // Apply seasonal price first
        if (room.seasonal_prices?.length > 0) {
            const date = new Date(selectedDate);

            const match = room.seasonal_prices.find(season => {
                const start = new Date(season.start_date);
                const end = new Date(season.end_date);

                return date >= start && date <= end;
            });

            if (match) {
                finalPrice = Number(match.price);
            }
        }

        // Apply discount AFTER seasonal
        if (
            room.discount_price &&
            Number(room.discount_price) < finalPrice
        ) {
            finalPrice = Number(room.discount_price);
        }

        return finalPrice;
    })();



    const savedAmount = isDiscounted
        ? Number(room.price) - Number(room.discount_price)
        : 0;

    const discountPercent = isDiscounted
        ? Math.round(((room.price - room.discount_price) / room.price) * 100)
        : 0;





    const isSeasonal = activeSeason && activeSeason.price;



    return (


        <>
            <Helmet>
                <title>
                    {room.meta_title || room.name}
                </title>

                <meta
                    name="description"
                    content={room.meta_description || room.description}
                />

                <link
                    rel="canonical"
                    href={`https://hotel.southtravels.com/hotels/${room.hotel?.slug}/${room.id}`}
                />

                {/* Open Graph */}
                <meta
                    property="og:title"
                    content={room.meta_title || room.name}
                />

                <meta
                    property="og:description"
                    content={room.meta_description || room.description}
                />

                <meta
                    property="og:url"
                    content={`https://hotel.southtravels.com/hotels/${room.hotel?.slug}/${room.id}`}
                />

                <meta
                    property="og:image"
                    content={`https://hotel.southtravels.com/uploads/rooms/${room.image}`}
                />

                {/* ADD THESE BELOW */}
                <meta property="og:type" content="website" />

                <meta name="robots" content="index, follow" />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content={room.meta_title || room.name}
                />

                <meta
                    name="twitter:description"
                    content={room.meta_description || room.description}
                />

                <meta
                    name="twitter:image"
                    content={`https://hotel.southtravels.com/uploads/rooms/${room.image}`}
                />
            </Helmet>


            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 bg-gray-50 min-h-screen pb-10">

                {/* 🔹 BREADCRUMB */}
                {/* ================= TOP NAV + HERO + GALLERY ================= */}


                {/* 🔹 TOP BAR */}
                <div className="flex items-center justify-between flex-wrap gap-3">

                    {/* Breadcrumb */}
                    <div className="flex items-center gap-2 text-sm text-gray-500">

                        <button
                            onClick={() => navigate("/")}
                            className="hover:text-teal-600 transition"
                        >
                            Home
                        </button>

                        <span className="text-gray-300">/</span>

                        <button
                            onClick={() => {
                                if (room?.hotel?.slug) {
                                    navigate(`/hotels/${room.hotel.slug}`);
                                } else {
                                    console.error("Hotel slug missing", room);
                                }
                            }}
                        >
                            {room.hotel?.name || "Hotel"}
                        </button>

                        <span className="text-gray-300">/</span>

                        <span className="text-gray-800 font-semibold">
                            Room {room.room_number}
                        </span>
                    </div>

                    {/* Back Button */}
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-1 text-sm text-gray-600 hover:text-teal-600 transition"
                    >
                        <span className="text-lg">←</span>
                        Back
                    </button>
                </div>


                {/* 🔹 HERO IMAGE */}
                <div className="mt-6 relative">

                    <div className="relative group">

                        <img
                            src={`https://hotel.southtravels.com/uploads/rooms/${activeImage}`}
                            className="w-full h-[420px] object-cover rounded-2xl shadow-md"
                        />

                        {/* Dark overlay */}
                        <div className="absolute inset-0 bg-black/20 rounded-2xl"></div>

                        {/* Content overlay */}
                        {/* Content overlay */}
                        <div className="absolute bottom-0 left-0 w-full p-6 bg-gradient-to-t from-black/80 to-transparent rounded-b-2xl">

                            <h1 className="text-white text-2xl md:text-3xl font-bold">
                                {room.room_number} ( {room.name} )
                            </h1>

                            <p className="text-gray-200 text-sm mt-1">
                                {room.hotel?.name}
                            </p>

                            {/* 🔥 BADGES */}
                            <div className="flex gap-2 mt-3 flex-wrap">

                                {isSeasonal && (
                                    <span className="bg-gradient-to-r from-orange-50 to-orange-100 text-orange-700 text-xs px-3 py-1 rounded-full font-semibold shadow-sm flex items-center gap-1 border border-orange-200 hover:shadow-md transition">
                                        <FaFire className="text-orange-500" />
                                        Limited Time Offer
                                    </span>
                                )}

                                {isDiscounted && (
                                    <span className="bg-green-100 text-green-700 text-xs px-3 py-1 rounded-full font-semibold shadow-sm border border-green-200 flex items-center gap-1">
                                        <FaTag className="text-green-600" />
                                        {discountPercent}% OFF
                                    </span>
                                )}

                            </div>

                            {/* Quick highlights */}
                            <div className="flex gap-4 mt-3 text-xs text-gray-300 flex-wrap">
                                <span>👤 {room.capacity} Guests</span>
                                <span>🛏 {room.bed_type}</span>
                                <span>📐 {room.size_sqm} m²</span>
                            </div>

                        </div>
                    </div>
                </div>


                {/* 🔹 IMAGE GALLERY */}
                {allImages.length > 0 && (
                    <div className="mt-5">

                        <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">

                            {allImages.map((img, i) => (
                                <img
                                    key={i}
                                    onClick={() => {
                                        setModalIndex(i);
                                        setShowModal(true);
                                        setActiveImage(img);
                                    }}
                                    src={`https://hotel.southtravels.com/uploads/rooms/${img}`}
                                    className={`w-28 h-20 object-cover rounded-lg cursor-pointer border-2 transition-all duration-200
                        ${activeImage === img
                                            ? "border-teal-500 scale-105"
                                            : "border-transparent hover:scale-105"
                                        }`}
                                />
                            ))}

                        </div>
                    </div>
                )}


                {/* 🔹 CONTENT */}
                <div className="max-w-7xl mx-auto py-14 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6 sm:gap-8">

                    {/* LEFT */}
                    <div className="md:col-span-2 space-y-6">

                        {/* TITLE */}
                        <div>
                            <h1 className="text-3xl font-bold">
                                {room.room_number}
                            </h1>
                            <p className="text-gray-500 mt-1">
                                Luxury stay with comfort & modern facilities
                            </p>
                        </div>

                        {/* INFO CARDS */}
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
                            {[
                                { label: "Capacity", value: room.capacity },
                                { label: "Bed Type", value: room.bed_type },
                                { label: "Beds", value: room.beds_count },
                                { label: "Size", value: `${room.size_sqm} m²` }
                            ].map((item, i) => (
                                <div key={i} className="bg-white p-4 rounded-xl shadow text-center">
                                    <p className="text-sm text-gray-500">{item.label}</p>
                                    <p className="font-bold text-lg">{item.value || "-"}</p>
                                </div>
                            ))}
                        </div>

                        {/* POLICIES */}
                        <div className="bg-white p-5 rounded-xl shadow">
                            <h2 className="text-xl font-semibold mb-3">Policies</h2>
                            <div className="grid grid-cols-2 gap-3 text-sm">
                                <p><b>Cancellation:</b> {room.cancellation_policy}</p>
                                <p><b>Availability:</b> {room.is_available ? "Available" : "Unavailable"}</p>
                                <p><b>Breakfast:</b> {room.breakfast_included ? "Included" : "Not Included"}</p>
                                <p><b>Smoking:</b> {room.smoking_allowed ? "Allowed" : "Not Allowed"}</p>
                            </div>
                        </div>

                        {/* AMENITIES */}
                        <div>
                            <h2 className="text-xl font-semibold mb-3">Amenities</h2>
                            <div className="flex flex-wrap gap-2">
                                {amenities.length > 0 ? amenities.map((a, i) => (
                                    <span key={i} className="bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-sm">
                                        {a}
                                    </span>
                                )) : (
                                    <p className="text-gray-400">No amenities listed</p>
                                )}
                            </div>
                        </div>

                        <div className="bg-teal-50 p-4 rounded-xl border border-teal-100">
                            <h3 className="font-semibold mb-2">Why choose this room?</h3>
                            <ul className="text-sm space-y-1 text-gray-700">
                                <li>• Prime location</li>
                                <li>• High guest rating</li>
                                <li>• Best price guarantee</li>
                            </ul>
                        </div>

                        {/* DESCRIPTION */}
                        <div className="bg-white p-5 rounded-xl shadow">
                            <h2 className="text-xl font-semibold mb-2">Description</h2>
                            <div
                                className="room-content prose max-w-none"
                                dangerouslySetInnerHTML={{
                                    __html: (room.description || "")
                                        .replace('<h3>Rate Plan</h3>', '<h3 class="rate-plan">Rate Plan</h3>')
                                        .replace('<h3>Features</h3>', '<h3 class="features">Features</h3>')
                                }}
                            />
                        </div>

                    </div>

                    {/* RIGHT BOOKING CARD */}
                    <div className="bg-white shadow-2xl rounded-2xl p-6 border sticky top-24 mt-4">

                        {/* Title */}
                        <h3 className="text-lg font-semibold text-gray-800">
                            Price Details
                        </h3>

                        <p className="text-xs text-gray-500 mt-1">
                            You won’t be charged yet
                        </p>

                        {/* PRICE */}
                        {/* PRICE */}
                        <div className="mt-4 flex items-end gap-2">
                            <h2 className="text-3xl font-bold text-teal-600">
                                {checkIn && checkOut
                                    ? roundPrice(getFinalPriceBreakdown().total).toLocaleString()
                                    : getFinalRoomPrice(room).toLocaleString()}
                            </h2>
                            <span className="text-gray-500 mb-1">AED</span>
                        </div>

                        {/* ✅ ADD HERE */}
                        {isSeasonal && (
                            <p className="text-xs text-orange-600 font-medium mt-1 flex items-center gap-1">
                                <FiClock />
                                Seasonal price (may change soon)
                            </p>
                        )}

                        {isSeasonal && room?.seasonal_price && (
                            <p className="text-sm text-orange-600 font-semibold flex items-center gap-1">
                                <FaFire className="text-orange-500 animate-pulse" />
                                Seasonal Deal: {Number(room.seasonal_price).toLocaleString()} AED
                            </p>
                        )}

                        {/*  DISCOUNT UI */}
                        {isDiscounted && (
                            <div className="mt-2 space-y-1">


                                <p className="text-sm">
                                    <span className="font-semibold text-teal-600">
                                        {nightlyRate.toLocaleString()} AED
                                    </span>

                                    <span className="text-gray-400 line-through ml-2">
                                        {Number(room.price).toLocaleString()} AED
                                    </span>
                                </p>

                                <p className="text-sm text-green-600 font-semibold flex items-center gap-1">
                                    <FaTag className="text-green-600" />
                                    You save {savedAmount.toLocaleString()} AED ({discountPercent}% OFF)
                                </p>

                            </div>
                        )}

                        {/* 🔥 SEASONAL MESSAGE */}
                        {isSeasonal && (
                            <div className="mt-3 p-4 rounded-xl bg-gradient-to-r from-orange-50 via-orange-50 to-amber-50 border border-orange-200 shadow-sm hover:shadow-md transition">

                                <p className="text-sm text-orange-700 font-semibold flex items-center gap-2">
                                    <FaFire className="text-orange-500" />
                                    Limited Time Seasonal Offer
                                </p>

                                <p className="text-xs text-orange-600 mt-1 leading-relaxed">
                                    Dynamic pricing applies — rates may change based on demand and availability.
                                </p>

                            </div>
                        )}

                        {/* 🔥 BREAKDOWN (REAL WORLD STYLE) */}
                        <div className="mt-5 space-y-2 text-sm">

                            {/* Base */}
                            {/* <div className="flex justify-between text-gray-600">
                                <span>Base price (per night)</span>
                                <span>
                                    {nightlyRate.toLocaleString()} AED
                                    {isDiscounted && (
                                        <span className="text-xs text-green-600 ml-2">
                                            (discount applied)
                                        </span>
                                    )}
                                </span>
                            </div> */}

                            <div className="flex justify-between text-gray-600">
                                <span>Base price (per night)</span>

                                <span className="flex items-center gap-2">
                                    {isDiscounted ? (
                                        <>
                                            <span className="font-semibold text-teal-600">
                                                {nightlyRate.toLocaleString()} AED
                                            </span>

                                            <span className="text-xs text-gray-400 line-through">
                                                {Number(room.price).toLocaleString()} AED
                                            </span>
                                        </>
                                    ) : (
                                        <span>
                                            {nightlyRate.toLocaleString()} AED
                                        </span>
                                    )}
                                </span>
                            </div>

                            {/* Service charge */}
                            <div className="flex justify-between text-gray-600">
                                <span>Service charge (10%)</span>
                                <span>
                                    {roundPrice(nightlyRate * 0.10).toLocaleString()} AED
                                </span>
                            </div>

                            {/* VAT */}
                            <div className="flex justify-between text-gray-600">
                                <span>VAT (5%)</span>
                                <span>
                                    {roundPrice(nightlyRate * 0.05).toLocaleString()} AED
                                </span>
                            </div>

                            {/* Tourism fee */}
                            <div className="flex justify-between text-gray-600">
                                <span>
                                    Tourism fee
                                    {Number(room?.hotel?.rating) === 5 && " (5-Star Hotel Fee)"}
                                </span>
                                <span>{getTourismFee()} AED</span>
                            </div>

                            <hr className="my-2" />

                            {/* Final per night */}
                            <div className="flex justify-between font-semibold text-gray-800">
                                <span>Final price / night</span>
                                <span className="text-teal-600">
                                    {getFinalRoomPrice(room).toLocaleString()} AED
                                </span>
                            </div>

                            {/* Total stay */}
                            {checkIn && checkOut && (
                                <>
                                    <div className="flex justify-between text-gray-700 font-medium mt-2">
                                        <span>Nights</span>
                                        <span>{getNights()}</span>
                                    </div>

                                    <div className="flex justify-between text-lg font-bold text-gray-900 mt-1">
                                        <span>Total</span>
                                        <span>
                                            {roundPrice(getFinalPriceBreakdown().total).toLocaleString()} AED
                                        </span>
                                    </div>
                                </>
                            )}
                        </div>

                        {/* BUTTON */}
                        <button
                            onClick={() => setShowBookingModal(true)}
                            className="w-full mt-6 py-3 rounded-xl text-lg font-semibold 
               bg-gradient-to-r from-teal-500 to-teal-600 
               hover:opacity-90 text-white shadow-lg transition"
                        >
                            Reserve Now
                        </button>

                        {/* FOOTER NOTE */}
                        <p className="text-xs text-gray-500 mt-3 text-center">
                            {room.cancellation_policy === "free"
                                ? "Free cancellation available"
                                : "Cancellation policy applies"}
                        </p>

                    </div>

                </div>

                {showModal && (
                    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50">

                        {/* Close */}
                        <button
                            onClick={() => setShowModal(false)}
                            className="absolute top-5 right-5 text-white text-3xl z-50"
                        >
                            ✕
                        </button>

                        {/* Prev */}
                        <button
                            onClick={() =>
                                setModalIndex((prev) =>
                                    prev === 0 ? allImages.length - 1 : prev - 1
                                )
                            }
                            className="absolute left-5 text-white text-5xl z-50 select-none"
                        >
                            ‹
                        </button>

                        {/* Next */}
                        <button
                            onClick={() =>
                                setModalIndex((prev) =>
                                    prev === allImages.length - 1 ? 0 : prev + 1
                                )
                            }
                            className="absolute right-5 text-white text-5xl z-50 select-none"
                        >
                            ›
                        </button>

                        {/* IMAGE WRAPPER (IMPORTANT PART) */}
                        <div className="flex items-center justify-center w-full h-full p-6">
                            <div className="max-w-4xl w-full max-h-[85vh] flex items-center justify-center">
                                <img
                                    src={`https://hotel.southtravels.com/uploads/rooms/${allImages[modalIndex]}`}
                                    className="max-h-[85vh] w-[85vh] object-contain rounded-xl shadow-2xl"
                                />
                            </div>
                        </div>

                        {/* Counter */}
                        <div className="absolute bottom-5 text-white text-sm">
                            {modalIndex + 1} / {allImages.length}
                        </div>

                    </div>
                )}

                {showBookingModal && (
                    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3 sm:p-4 overflow-y-auto">

                        {/* Modal Box */}
                        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-5 sm:p-6 relative max-h-[90vh] overflow-y-auto overflow-x-hidden min-w-0">

                            {/* Close */}
                            <button
                                onClick={() => setShowBookingModal(false)}
                                className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl"
                            >
                                ✕
                            </button>

                            {/* Header */}
                            <h3 className="text-xl sm:text-2xl font-semibold">
                                Complete your booking
                            </h3>

                            <p className="text-xs text-gray-500 mt-1">
                                You won’t be charged yet — final price includes taxes & fees
                            </p>

                            {/* FORM */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5 w-full min-w-0 overflow-hidden">

                                {/* Name */}
                                <div>
                                    <label className="text-sm text-gray-600">Your Name</label>
                                    <input
                                        type="text"
                                        value={name}
                                        onChange={e => setName(e.target.value)}
                                        className="w-full border p-2.5 rounded-lg mt-1 focus:ring-2 focus:ring-teal-400 outline-none box-border"
                                    />
                                </div>

                                {/* Email */}
                                <div>
                                    <label className="text-sm text-gray-600">Email</label>
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        className="w-full border p-2.5 rounded-lg mt-1 focus:ring-2 focus:ring-teal-400 outline-none box-border"
                                    />
                                </div>

                                {/* Phone */}
                                <div>
                                    <label className="text-sm text-gray-600">Phone</label>
                                    <input
                                        type="tel"
                                        value={phone}
                                        onChange={e => setPhone(e.target.value)}
                                        className="w-full border p-2.5 rounded-lg mt-1 focus:ring-2 focus:ring-teal-400 outline-none box-border"
                                    />
                                </div>

                                {/* Guests */}
                                <div>
                                    <label className="text-sm text-gray-600">Guests</label>
                                    <input
                                        type="number"
                                        min="1"
                                        value={guests}
                                        onChange={e => setGuests(e.target.value)}
                                        className="w-full border p-2.5 rounded-lg mt-1 focus:ring-2 focus:ring-teal-400 outline-none box-border"
                                    />
                                </div>


                                {/* <div>
                                    <label className="text-sm text-gray-600">Check-in</label>
                                    <input
                                        type="date"
                                        value={checkIn}
                                        min={today}
                                        onChange={e => {
                                            setCheckIn(e.target.value);
                                            if (checkOut && e.target.value > checkOut) setCheckOut("");
                                        }}
                                        className="w-full border p-2.5 rounded-lg mt-1 focus:ring-2 focus:ring-teal-400 outline-none box-border"
                                    />
                                </div>

                                
                                <div>
                                    <label className="text-sm text-gray-600">Check-out</label>
                                    <input
                                        type="date"
                                        value={checkOut}
                                        min={checkIn || today}
                                        onChange={e => setCheckOut(e.target.value)}
                                        className="w-full border p-2.5 rounded-lg mt-1 focus:ring-2 focus:ring-teal-400 outline-none box-border"
                                    />
                                </div> */}


                                {/* Check-in */}
                                <div className="w-full min-w-0 overflow-hidden">
                                    <label className="text-sm text-gray-600 block">
                                        Check-in
                                    </label>

                                    <input
                                        type="date"
                                        value={checkIn}
                                        min={today}
                                        onChange={e => {
                                            setCheckIn(e.target.value);

                                            if (checkOut && e.target.value > checkOut) {
                                                setCheckOut("");
                                            }
                                        }}
                                        className="
    w-full
    h-[42px]
    min-w-0
    border
    border-gray-300
    rounded-lg
    mt-1
    px-3
    text-sm
    focus:ring-2
    focus:ring-teal-400
    outline-none
    box-border
"
                                    />
                                </div>

                                {/* Check-out */}
                                <div className="w-full min-w-0 overflow-hidden">
                                    <label className="text-sm text-gray-600 block">
                                        Check-out
                                    </label>

                                    <input
                                        type="date"
                                        value={checkOut}
                                        min={checkIn || today}
                                        onChange={e => setCheckOut(e.target.value)}
                                        className="
    w-full
    h-[42px]
    min-w-0
    border
    border-gray-300
    rounded-lg
    mt-1
    px-3
    text-sm
    focus:ring-2
    focus:ring-teal-400
    outline-none
    box-border
"
                                    />
                                </div>


                            </div>

                            {/* 🔥 PRICE BREAKDOWN */}
                            <div className="mt-6 bg-gray-50 rounded-xl p-4 border">

                                <p className="text-sm font-semibold text-gray-700">
                                    Price summary
                                </p>

                                <div className="mt-3 space-y-2 text-sm">

                                    {/* Base */}
                                    <div className="flex justify-between text-gray-600">
                                        <span>Base price / night</span>
                                        <span>{nightlyRate.toLocaleString()} AED</span>
                                    </div>

                                    {/* VAT */}
                                    <div className="flex justify-between text-gray-600">
                                        <span>VAT (5%)</span>
                                        <span>{roundPrice(nightlyRate * 0.05).toLocaleString()} AED</span>
                                    </div>

                                    {/* Service */}
                                    <div className="flex justify-between text-gray-600">
                                        <span>Service charge (10%)</span>
                                        <span>{roundPrice(nightlyRate * 0.10).toLocaleString()} AED</span>
                                    </div>

                                    {/* Tourism */}
                                    <div className="flex justify-between text-gray-600">
                                        <span>
                                            Tourism fee
                                            {Number(room?.hotel?.rating) === 5 && " (5-Star Hotel Fee)"}
                                        </span>
                                        <span>{getTourismFee()} AED</span>
                                    </div>

                                    <hr className="my-2" />

                                    {/* Final per night */}
                                    <div className="flex justify-between font-semibold text-gray-800">
                                        <span>Final price / night</span>
                                        <span className="text-teal-600">
                                            {getFinalRoomPrice(room).toLocaleString()} AED
                                        </span>
                                    </div>

                                    {/* Total */}
                                    {checkIn && checkOut && (
                                        <>
                                            <div className="flex justify-between text-gray-600 mt-2">
                                                <span>Nights</span>
                                                <span>{getNights()}</span>
                                            </div>

                                            <div className="flex justify-between text-lg font-bold text-gray-900">
                                                <span>Total</span>
                                                <span>
                                                    {roundPrice(getFinalPriceBreakdown().total).toLocaleString()} AED
                                                </span>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Selected Room */}
                            <div className="mt-4 p-4 bg-teal-50 rounded-xl border border-teal-100">
                                <p className="text-sm text-gray-500">Selected Room</p>

                                <p className="font-semibold text-lg">
                                    Room {room.room_number}
                                </p>

                                <p className="text-teal-600 font-bold text-lg mt-1">
                                    {nightlyRate} AED
                                    <span className="text-sm font-normal text-gray-500">
                                        / per night
                                    </span>
                                </p>

                                {/*  DISCOUNT INFO */}
                                {isDiscounted && (
                                    <p className="text-xs text-green-600 mt-1">
                                        Discount applied — you save {savedAmount} AED per night
                                    </p>
                                )}

                                {/* 🔥 SEASONAL */}
                                {isSeasonal && (
                                    <p className="text-xs text-orange-600 font-medium flex items-center gap-1 leading-relaxed">
                                        <FaFire className="text-orange-500" />
                                        Seasonal rate applied — pricing is limited-time and may change
                                    </p>
                                )}
                            </div>

                            {/* BUTTON */}
                            <button
                                onClick={handleBooking}
                                disabled={bookingLoading}
                                className={`w-full mt-6 py-3 rounded-xl font-medium text-white transition flex items-center justify-center gap-2
                ${bookingLoading
                                        ? "bg-gray-300 cursor-not-allowed"
                                        : "bg-teal-500 hover:bg-teal-600"
                                    }`}
                            >
                                {bookingLoading ? (
                                    <>
                                        <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                        Processing...
                                    </>
                                ) : (
                                    "Confirm Booking"
                                )}
                            </button>

                        </div>
                    </div>
                )}


            </div>
        </>

    );


}